// angular
//     .module('HeroPRO')
const HPNotifications = {
    CSLB: {
        actionItemTypeId: 22,
        template: 'app/notificationCenter/modal/templates/contractorCSLB/contractorCSLB.html',
        menuText: 'Contractor CSLB Required',
    },
    MandatoryTraining: {
        actionItemTypeId: 18,
        template: 'app/notificationCenter/modal/training/trainingContent.html',
        menuText: 'Required training',
    },
    DelayedMandatoryTraining: {
        actionItemTypeId: 19,
        template: 'app/notificationCenter/modal/training/trainingContent.html',
        menuText: 'Required training',
    },
    MandatoryTrainingDaysLeft: {
        actionItemTypeId: 1,
        template: '',
        menuText: 'Required training',
    },
    Ach: {
        actionItemTypeId: 16,
        template: 'app/notificationCenter/modal/templates/addBankInfo/addBankInfo.html',
        menuText: "Company's bank info",
    },
    TurningOffAccess: {
        actionItemTypeId: 20,
        template: 'app/notificationCenter/modal/templates/territoryUpdate/territoryUpdate.html',
        menuText: 'Territory Update',
    },
    AdvancedRegistration: {
        actionItemTypeId: 21,
        template: 'app/notificationCenter/modal/templates/advancedRegistration/advancedRegistration.html',
        menuText: 'Advanced Registration',
    },
    TermsAndConditions: {
        actionItemTypeId: 14,
        template: 'app/notificationCenter/modal/templates/termsSign/termsSign.html',
        menuText: 'Get Started',
    },
    MandatoryPCC: {
        actionItemTypeId: 23,
        template: 'app/notificationCenter/modal/templates/pcc/pcc.html',
        menuText: 'HIS Status',
    },
    ReminderPCC: {
        actionItemTypeId: 24,
        template: 'app/notificationCenter/modal/templates/pcc/pcc.html',
        menuText: 'HIS Status',
    },
    HISCodeOfConduct: {
        actionItemTypeId: 25,
        template: 'app/notificationCenter/modal/templates/hisCodeOfConduct/hisCodeOfConduct.html',
        menuText: 'CA HERO Role Overview',
    },
    LACountyTurnOff: {
        actionItemTypeId: 26,
        template: 'app/notificationCenter/modal/templates/territoryUpdate/territoryUpdateLAC.html',
        menuText: 'Territory Update',
    }
};

export default HPNotifications;



// WEBPACK FOOTER //
// ./src/app/config/constants/NotificationTypes.constant.js